import { ca } from '@cian/analytics';

interface IParams {
  optionValue: boolean;
  formId: string;
  offerId: number | null;
}

export const trackLayoutOptionClick = ({ optionValue, formId, offerId }: IParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerId ? 'Edit_ad' : 'New_ad',
    action: 'Click_sopr',
    label: optionValue ? 'is_layout_approved_yes' : 'is_layout_approved_no',
    page: {
      pageType: 'AddForm',
      extra: {
        offerId,
        form_id: formId,
      },
    },
  });
};
